import { SVGProps } from 'react'

const LogoFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={
      {
        enableBackground: 'new 0 0 96 27'
      } as any
    }
    viewBox="0 0 96 27"
    width={96}
    height={27}
    fill="currentColor"
    {...props}
  >
    <path d="m29.4 3.3-7.2 18.4H21l-5-11.3-5.1 11.3H9.7L2.5 3.3h4.1l4 10.7 4.7-11h1.2l4.7 10.9 4-10.6h4.2zM36.1 7.5c4-.1 7.3 3.2 7.3 7 .1 3.9-3.3 7.2-7.3 7.1-4 .1-7.3-3.2-7.2-7.1-.1-3.8 3.2-7 7.2-7zm0 3.4c-2 0-3.5 1.6-3.5 3.7s1.4 3.7 3.5 3.7c2 0 3.5-1.6 3.5-3.7s-1.5-3.7-3.5-3.7zM54.1 11.1h-1c-2.2 0-3.6 1.2-3.6 3.5v6.7h-3.7V7.8h3.4v1.6c.9-1.1 2.2-1.8 3.7-1.8.5 0 .8.1 1.2.2v3.3zM63.7 21.7c-1.6 0-3.1-.6-4-1.6v6.2H56V7.8h3.4v1.7c.9-1.3 2.5-2 4.3-2 3.8 0 6.6 3 6.6 7s-2.8 7.2-6.6 7.2zm-.9-10.8c-1.9 0-3.4 1.3-3.4 3.7 0 2.4 1.5 3.7 3.4 3.7 2 0 3.5-1.5 3.5-3.7 0-2.3-1.5-3.7-3.5-3.7zM72.5 7.8h3.7v13.5h-3.7V7.8zM88.7 21.4l-5.4-7.5v7.5h-3.7V.9h3.7v12.7l4.9-5.8h4.4l-5.1 6 5.5 7.5h-4.3zM74.3.6c1.3 0 2.4 1 2.4 2.3 0 1.3-1.1 2.3-2.4 2.3-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3z" />
  </svg>
)
export default LogoFull
